import { useSignOut } from "@/providers/boot-manager";
import { AccountSwitcher } from "./account-switcher";
import { useAccountSwitcher } from "./use-account-switcher";

/**
 * Single mount of the {@link AccountSwitcher} overlay.
 *
 * Why a dedicated host: the app renders the sidebar TWICE (a mobile drawer and a
 * desktop rail). If each sidebar mounted its own `<AccountSwitcher>` Dialog,
 * opening the switcher would open BOTH at once → two stacked overlays, the top
 * one intercepting all pointer events (so "Add account" / "Continue as guest"
 * became unclickable). We mount it ONCE here at the layout level; the
 * per-sidebar trigger buttons just flip the shared singleton state.
 */
export function AccountSwitcherHost() {
  const { isOpen, setOpen } = useAccountSwitcher();
  const { promptSignOut } = useSignOut();

  return (
    <AccountSwitcher
      open={isOpen()}
      onOpenChange={setOpen}
      onSignOut={() => {
        setOpen(false);
        promptSignOut();
      }}
    />
  );
}
